import { DEFAULT_BOUNDS_CZECHIA } from "src/consts";
import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { ISearchFilterState } from "utils/search";

export type TCreateWatchDogInput = {
  email: string;
  name: string;
  offerTypeId: number;
  // frequencyId: EWatchdogFrequency;
  frequencyId: any; // FIXME: correct type
  // bounds: IGeoBounds;
  filter: ISearchFilterState;
  location: string;
};

type TOutput = {
  msg?: string;
  status?: string;
  error_id?: string;
};

export default class CreateWatchdogApiEndpoint extends BaseRestApiEndpoint<
  TCreateWatchDogInput,
  TOutput
> {
  method = ERestApiMethod.POST;
  allowedStatusCodes = [403];

  resolveUri(): string {
    return `/fe-api/watchdog`;
  }

  mapRequestData({
    name,
    frequencyId,
    email,
    filter: {
      bounds,
      price,
      area,
      dispositions,
      furnishing,
      conveniences,
      noCommitionFee,
    },
    offerTypeId,
    location,
  }: TCreateWatchDogInput): any {
    return {
      name,
      frequency_id: frequencyId,
      search: {
        query: location,
        offer_type_id: offerTypeId.toString(),
        dispositions: dispositions
          ? dispositions.map((d) => d.apiIds).flat()
          : [],
        price_from: price.min !== null ? price.min.toString() : "",
        price_to: price.max !== null ? price.max.toString() : "",
        _acreage_from: area.min !== null ? area.min.toString() : "",
        get acreage_from() {
          return this._acreage_from;
        },
        set acreage_from(value) {
          this._acreage_from = value;
        },
        acreage_to: area.max !== null ? area.max.toString() : "",
        added_before: "",
        furnishing: furnishing ? furnishing.map((f) => f.apiId) : [],
        conveniences: conveniences ? conveniences.map((c) => c.apiId) : [],
        is_price_commision_free: noCommitionFee
          ? noCommitionFee.toString()
          : null,
        sort_by: "",
        page: 1,
        limit: 20,
        bounds: bounds
          ? {
              north_east: bounds.northEast,
              south_west: bounds.southWest,
            }
          : {
              north_east: DEFAULT_BOUNDS_CZECHIA.northEast,
              south_west: DEFAULT_BOUNDS_CZECHIA.southWest,
            },
        name,
        frequency_id: frequencyId,
      },
      count: 297, // FIXME: wtf is this param?
      user: {
        email,
      },
      source: "search_button_form",
    };
  }
}
